import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { Space } from '@playq/octopus2-apps';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

import { updateSpaceMutationKey } from './constants';

export const useSpaceUpdate = (options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, Space>) =>
  useEitherMutation((space) => services2.spacesService.update(space), {
    mutationKey: updateSpaceMutationKey,
    ...options,
  });
